"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trustupWebsocket = void 0;
var laravel_echo_1 = require("laravel-echo");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var Pusher = require("pusher-js");
var TrustupWebsocketIoClient = /** @class */ (function () {
    function TrustupWebsocketIoClient(config) {
        // eslint-disable-next-line no-console
        this.echoInstance = new laravel_echo_1.default({
            broadcaster: "pusher",
            key: (config === null || config === void 0 ? void 0 : config.key) ||
                "$2y$10$svQIJ8lZEqclI9AqcZEBZeKEqhePKWoFTFU85ML2u9w4aa2wbRHG",
            wsHost: (config === null || config === void 0 ? void 0 : config.host) || "websocket.trustup.io",
            wsPort: (config === null || config === void 0 ? void 0 : config.port) || 443,
            wssPort: (config === null || config === void 0 ? void 0 : config.port) || 443,
            disableStats: true,
        });
    }
    TrustupWebsocketIoClient.prototype.echo = function () {
        return this.echoInstance;
    };
    return TrustupWebsocketIoClient;
}());
var trustupWebsocket = new TrustupWebsocketIoClient();
exports.trustupWebsocket = trustupWebsocket;
exports.default = TrustupWebsocketIoClient;
